import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { SegregatedDataEncryptionFormPresentation } from './segregated-data-encryption-form.presentation';
import { SegregatedDataEncryptionFormVM } from './segregated-data-encryption-form.viewmodel';

interface IProps {
    vm: SegregatedDataEncryptionFormVM;
}

const SegregatedDataEncryptionFormContainer = withViewModel(
    SegregatedDataEncryptionFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { SegregatedDataEncryptionFormContainer as SegregatedDataEncryptionForm };